import { Spin, Table } from 'antd';
import moment from 'moment';
import React from 'react';
import { countryMapList } from '../../../../data/countryMapList';
import './AlumniTable.scss';

const AlumniTable = ({
  data,
  current,
  totalCount,
  onPaginationChange,
  fetching,
  offset
}) => {
  const columnsCollection = {
    noIndex: {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, record, index) => {
        const label = <span>{offset + index + 1}</span>;
        return label;
      }
    },
    name: {
      title: 'Name',
      dataIndex: 'fullName',
      key: 'fullName',
      render: (value, record) => {
        return <span>{record.fullName}</span>;
      }
    },
    email: {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (value, record) => {
        return <span>{record.email}</span>;
      }
    },
    code: {
      title: 'Course Offer Code',
      dataIndex: 'code',
      key: 'code',
      render: (value, record) => {
        return <span>{record.code}</span>;
      }
    },
    startDate: {
      title: 'MMYY',
      dataIndex: 'startDate',
      key: 'startDate',
      sorter: (a, b) =>
        moment(a?.startDate).unix() - moment(b?.startDate).unix(),
      render: (value, record) => {
        const dateObject = new Date(record.startDate);
        const dateString = dateObject.toLocaleDateString();

        return <span>{dateString}</span>;
      }
    },
    courseTitle: {
      title: 'Course Name',
      dataIndex: 'courseTitle',
      key: 'courseTitle',
      render: (value, record) => {
        return <span>{record?.description.split('|')[0]}</span>;
      }
    },
    country: {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
      render: (value, record) => {
        return <span>{countryMapList[record?.countryId]
          ?.name}</span>;
      }
    },
    repeat: {
      title: 'Repeat',
      dataIndex: 'repeat',
      key: 'repeat',
      render: (value, record) => {
        return <span>{record.repeat}</span>;
      }
    }
  };

  const renderColumns = () => {
    const columns = [
      'noIndex',
      'name',
      'email',
      'code',
      'startDate',
      'courseTitle',
      'country',
      'repeat',
    ];
    return columns.map((item) => columnsCollection[item]);
  };
  return (
  <div>
    {fetching ? <Spin /> : null}
    {data.length > 0 ? (
      <div>
        <div>Total count: {totalCount}</div>
        <Table
          rowClassName={(record, index) => record?.repeat > 2 ? 'repeat-student' :  'non-repeated-student'}
          columns={renderColumns()}
          tableLayout="auto"
          dataSource={data}
          expandable={{ defaultExpandAllRows: true }}
          pagination={{
            current,
            total: totalCount,
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30']
          }}
          onChange={onPaginationChange}
        />
      </div>
    ) : null}
    {data.length === 0 && !fetching ? <div>No record found</div> : null}
  </div>
)};

export default AlumniTable;
